import { render, staticRenderFns } from "./EditBusinessAddress.vue?vue&type=template&id=5a1381d6&"
import script from "./EditBusinessAddress.vue?vue&type=script&lang=js&"
export * from "./EditBusinessAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports